module.exports = __webpack_public_path__ + "static/Jointhepipe-7568b690feb200bbcfa2fbeb7525e2dd.png";